export default class Logger {
    constructor(){
        this.error = this.erroor.bind(this);
    }

    static error(message) {
        if (process.env.NODE_ENV !== "production") {
            if( typeof message === "string") {
                // eslint-disable-next-line  no-console
                console.error(message);
            }
            else if( typeof message === "object") {
                if( message.message ) {
                    // eslint-disable-next-line  no-console
                    console.error(message.message);
                } else {
                    // eslint-disable-next-line  no-console
                    console.error(JSON.stringify(message, null, 2));
                }
            }
            else {
                // eslint-disable-next-line  no-console
                console.error("unknown error message");
            }
        }
    }
}